<template>
  <div class="Navbar">
    <div class="Navbar__Logo">
      <Picture name="logo-daas-white" />
    </div>
  </div>
</template>

<script>
import { Picture } from 'daas-components';
export default {
  name: 'Navbar',
  components: {
    Picture,
  },
};
</script>

<style lang="scss">
.Navbar {
  @include z-index(Navbar);
  background: $navbar;
  height: $navbar-height;
  position: fixed;
  width: $navbar-width-full;
  padding: 0 rem(30);
  right: 0;
  &__Logo {
    width: rem(80);
    padding-top: rem(10);
  }
}
</style>
